export default "__VITE_ASSET__BySdK9tZ__"